<template>
    <div v-if="images.length > 0" :class="['header-gallery', {'edge-to-edge': !roundedCorners}]" :style="`background-color: ${backgroundColor}`">
        <div class="row no-gutters h-100">
            <div class="col h-100">
                <div @click="showLightbox(0)" :class="['cover-image h-100', {left: roundedCorners, 'right-sm-down': roundedCorners, right: roundedCorners && images.length < 3}]" :style="`background-image: url('${images[0].permalink}${urlParams(images[0])}');`">
                    <a class="credits" v-if="images[0].oembed != null" @click.stop :href="images[0].oembed.web_page_short_url" target="_blank">
                        &#128248;: {{ images[0].oembed.title }} by {{ images[0].oembed.author_name }}
                    </a>
                </div>
            </div>
            
            <div v-if="images.length > 2" :class="['vert d-none d-md-block', {'col-xl-7': images.length > 4, 'col-4': images.length > 2}]">
                <div class="row no-gutters h-100">
                    <div class="col h-100">
                        <div class="row no-gutters h-50">
                            <div class="col h-100">
                                <div @click="showLightbox(1)" class="cover-image" :style="`background-image: url('${images[1].permalink}${urlParams(images[1])}');`" :class="{'top-right': roundedCorners && images.length < 5, 'top-right-lg-down': roundedCorners}">
                                    <a class="credits" v-if="images[1].oembed != null" @click.stop :href="images[1].oembed.web_page_short_url" target="_blank">
                                        &#128248;: {{ images[1].oembed.title }} by {{ images[1].oembed.author_name }}
                                    </a>
                                </div>
                            </div>
                            <div v-if="images.length > 4" class="col d-none d-xl-block h-100">
                                <div @click="showLightbox(3)" :class="['cover-image', {'top-right': roundedCorners}]" :style="`background-image: url('${images[3].permalink}${urlParams(images[3])}');`">
                                    <a class="credits" v-if="images[3].oembed != null" @click.stop :href="images[3].oembed.web_page_short_url" target="_blank">
                                        &#128248;: {{ images[3].oembed.title }} by {{ images[3].oembed.author_name }}
                                    </a>
                                </div>
                            </div>
                        </div>
                        
                        <div class="row no-gutters h-50">
                            <div class="col h-100">
                                <div @click="showLightbox(2)" class="cover-image" :style="`background-image: url('${images[2].permalink}${urlParams(images[2])}');`" :class="{'bottom-right': roundedCorners && images.length < 5, 'bottom-right-lg-down': roundedCorners}">
                                    <a class="credits" v-if="images[2].oembed != null" @click.stop :href="images[2].oembed.web_page_short_url" target="_blank">
                                        &#128248;: {{ images[2].oembed.title }} by {{ images[2].oembed.author_name }}
                                    </a>
                                </div>
                            </div>
                            <div v-if="images.length > 4" class="col d-none d-xl-block h-100">
                                <div @click="showLightbox(4)" :class="['cover-image', {'bottom-right': roundedCorners}]" :style="`background-image: url('${images[4].permalink}${urlParams(images[4])}');`">
                                    <a class="credits" v-if="images[4].oembed != null" @click.stop :href="images[4].oembed.web_page_short_url" target="_blank">
                                        &#128248;: {{ images[4].oembed.title }} by {{ images[4].oembed.author_name }}
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="action-buttons">
                <slot name="action-button"></slot>
                <a v-if="lightboxImages.length > 1" href="#" @click.prevent="showLightbox(0)" class="btn btn-lg btn-primary shadow ml-2">View all Photos</a>
            </div>
        </div>
        <CoolLightBox 
            v-if="lightboxImages.length"
            :items="lightboxImages" 
            :index="lightboxSlide"
            @close="lightboxSlide = null">
        </CoolLightBox>
    </div>
</template>

<script>
import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css'
import CoolLightBox from 'vue-cool-lightbox'

export default {
    name: 'HeaderGallery',
    components: { 
        CoolLightBox,
    },
    props: {
        backgroundColor: {
            type: String,
            default() { return 'transparent' },
        },
        images: {
            type: Array,
            default() { return [] },
        },
        roundedCorners: {
            type: Boolean,
            default() { return true },
        },
    },
    data() {
        return {
            lightboxSlide: null,
        }
    },
    computed: {
        lightboxImages() {
            return this.images.map(image => image.permalink)
        },
    },
    methods: {
        urlParams(image) {
            if (image.params) {
                let params = JSON.parse(image.params)
                return '?w=1600&ar=1.85:1&' + Object.objectAsQueryString(params)
            }
            return '?w=1600&ar=1.85:1&fit=crop&crop=faces,entropy'
        },
        showLightbox(slideNum) {
            this.lightboxSlide = slideNum
        }
    },
};
</script>

<style lang="scss">
.header-gallery {
    height: 60vh;
    min-height: 300px;
    
    @include media-breakpoint-down(sm) {
        height: 30vh;
    }
    
    &.edge-to-edge {
        margin-left: -1px;
        width: calc(100% + 2px);
    }
    
    .row {
        position: relative;
    }
    
    & > .row > .vert > .row > .col > .row {
        height: 50%;
    }
    
    .cover-image {
        height: 100%;
        background-position: center center;
        background-size: cover;
        border: 1px solid $almost-white;
        transition: opacity .25s ease-in-out;
        cursor: pointer;
        
        .credits {
            display: block;
            position: absolute;
            text-align: center;
            font-weight: bold;
            bottom: 1px;
            left: 1px;
            right: 1px;
            color: white;
            font-size: 9px;
            // background: rgba(0,0,0,.2);
            text-shadow: 0 0 15px black;
            padding: 10px;
        }
        
        &:hover {
            // opacity: .7;
        }
        
        &.left, &.left .credits {
            border-top-left-radius: 24px;
            border-bottom-left-radius: 24px;
        }
        &.right, &.right .credits {
            border-top-right-radius: 24px;
            border-bottom-right-radius: 24px;
        }
        &.right-sm-down, &.right-sm-down .credits {
            @include media-breakpoint-down(sm) {
                border-top-right-radius: 24px;
                border-bottom-right-radius: 24px;
            }
        }
        &.top-right, &.top-right .credits {
            border-top-right-radius: 24px;
        }
        &.bottom-right, &.bottom-right .credits {
            border-bottom-right-radius: 24px;
        }
        &.top-right-lg-down, &.top-right-lg-down .credits {
            @include media-breakpoint-down(lg) {
                border-top-right-radius: 24px;
            }
        }
        &.bottom-right-lg-down, &.bottom-right-lg-down .credits {
            @include media-breakpoint-down(lg) {
                border-bottom-right-radius: 24px;
            }
        }
        
        .credits {
            border-top-right-radius: 0 !important;
            border-top-left-radius: 0 !important;
        }
    }
    
    .action-buttons {
        position: absolute;
        bottom: 20px;
        right: 20px;
        
        @include media-breakpoint-between(xs,sm) {
            left: 20px;
            bottom: 40px;
            text-align: center;
            
            .btn {
                @include button-size($input-btn-padding-y-sm, $input-btn-padding-x-sm, $font-size-sm, $line-height-sm, $btn-border-radius-sm);
            }
        }
    }
}
</style>


